import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.less';
import './bamboo.less';
import { Provider } from 'react-redux';
import AppRoute from './routes';
import { store } from './store';
import ErrorBoundary from './ErrorBoundry';
import { EventBridge } from './commons/EventBridge/EventBridge';
import { isInternalPlatform } from './commons/Utils/authUtils';

const appName = `${process.env.REACT_APP_MICROFRONTEND_MODULE_NAME || ''}`;
// const clevertapId = `${process.env.REACT_APP_CLEVERTAP_ID || ''}`;

// clevertap.privacy.push({optOut: false});
// clevertap.privacy.push({useIP: false}) ;
// clevertap.init(clevertapId);
// clevertap.spa = true;

function App() {
  const events = new EventBridge({ persistedTopics: ['notification'] });

  window.notificationEvents = events;

  return (
    <ErrorBoundary>
      <div
        className={`${appName} ${isInternalPlatform() ? 'internal-app' : ''}`}
        id={appName}
      >
        <Provider store={store}>
          <BrowserRouter>
            <AppRoute />
          </BrowserRouter>
        </Provider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
